import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    SilDeviceType,
    SilDeviceFilters,
    SortSilDevices,
    setSilModelDevicesProjectDeviceIds,
    setSilModelDevicesProjectDeviceSort,
    setSilModelDevicesProjectDeviceFilters,
} from "client/store"
import {
    PageContent,
    Table,
    TableSearchWrapper,
    SortRows,
} from "client/components"

import SilDeviceSearch from "client/pages/search/silDeviceSearch"
import Columns from "./columns"

const ProjectDevices = () => {
    const deviceList = useSelector((state: StoreType) => state.silModelDevices.projectDevices.deviceList)
    const deviceIds = useSelector((state: StoreType) => state.silModelDevices.projectDevices.deviceIds)
    const sortColumn = useSelector((state: StoreType) => state.silModelDevices.projectDevices.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.silModelDevices.projectDevices.sortOrder)
    const filters = useSelector((state: StoreType) => state.silModelDevices.projectDevices.filters)

    const dispatch = useDispatch()

    useEffect(() => {
        const sortedIds = SortSilDevices(Object.values(deviceList), sortColumn, sortOrder, filters)
        dispatch(setSilModelDevicesProjectDeviceIds(sortedIds))
    }, [deviceList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof SilDeviceType, order) => {
        dispatch(setSilModelDevicesProjectDeviceSort(column, order))
    }

    const onFilter = (newFilters: SilDeviceFilters) => {
        dispatch(setSilModelDevicesProjectDeviceFilters(newFilters))
    }

    const columns = Columns(true)

    return (
        <PageContent>
            <TableSearchWrapper>
                <SilDeviceSearch
                    id="projectDevices"
                    filters={filters}
                    onFilter={onFilter}
                />
            </TableSearchWrapper>
            <Table
                columns={columns}
                dataList={deviceList}
                dataIds={deviceIds}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                rowSize="md"
                showPagination
                onSort={onSort}
            />
        </PageContent>
    )
}
export default ProjectDevices
